import { API_BASE_URL } from "../../config";

class PolicyRepository {
  // Get KVKK (Data Protection Notice)
  async getDataProtectionNotice(lang = 'tr') {
    try {
      const response = await fetch(`${API_BASE_URL}/policy/data-protection-notice?lang=${lang}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching data protection notice:', error);
      throw error;
    }
  }

  // Get Disclosure Text (Aydınlatma Metni)
  async getDisclosure(lang = 'tr') {
    try {
      const response = await fetch(`${API_BASE_URL}/policy/disclosure?lang=${lang}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching disclosure:', error);
      throw error;
    }
  }

  // Get all policies
  async getAllPolicies(lang = 'tr') {
    try {
      const [dataProtection, disclosure] = await Promise.all([
        this.getDataProtectionNotice(lang),
        this.getDisclosure(lang)
      ]);
      
      return {
        dataProtectionNotice: dataProtection,
        disclosure: disclosure
      };
    } catch (error) {
      console.error('Error fetching all policies:', error);
      throw error;
    }
  }
}

export default new PolicyRepository();
